function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import hotkeys from 'hotkeys-js';
import { StimulusUse } from '../stimulus-use';
export var UseHotkeys = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseHotkeys, _StimulusUse);

  var _super = _createSuper(UseHotkeys);

  function UseHotkeys(controller, hotkeysOptions) {
    var _this;

    _classCallCheck(this, UseHotkeys);

    _this = _super.call(this, controller, hotkeysOptions);

    _this.bind = function () {
      var _loop = function _loop() {
        var _ref = _Object$entries[_i2];
        _ref2 = _slicedToArray(_ref, 2);
        var hotkey = _ref2[0];
        var definition = _ref2[1];
        var handler = definition.handler.bind(_this.controller);
        hotkeys(hotkey, definition.options, function (e) {
          return handler(e, e);
        });
      };

      for (var _i2 = 0, _Object$entries = Object.entries(_this.hotkeysOptions.hotkeys); _i2 < _Object$entries.length; _i2++) {
        var _ref2;

        _loop();
      }
    };

    _this.unbind = function () {
      for (var hotkey in _this.hotkeysOptions.hotkeys) {
        hotkeys.unbind(hotkey);
      }
    };

    _this.controller = controller;
    _this.hotkeysOptions = hotkeysOptions;

    _this.enhanceController();

    _this.bind();

    return _this;
  }

  _createClass(UseHotkeys, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this2 = this;

      if (this.hotkeysOptions.filter) {
        hotkeys.filter = this.hotkeysOptions.filter;
      }

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this2.unbind();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseHotkeys;
}(StimulusUse);

var convertSimpleHotkeyDefinition = function convertSimpleHotkeyDefinition(definition) {
  return {
    handler: definition[0],
    options: {
      element: definition[1]
    }
  };
};

var coerceOptions = function coerceOptions(options) {
  if (!options.hotkeys) {
    var _hotkeys = {};
    Object.entries(options).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          hotkey = _ref4[0],
          definition = _ref4[1];

      Object.defineProperty(_hotkeys, hotkey, {
        value: convertSimpleHotkeyDefinition(definition),
        writable: false,
        enumerable: true
      });
    });
    options = {
      hotkeys: _hotkeys
    };
  }

  return options;
};

export var useHotkeys = function useHotkeys(controller, options) {
  return new UseHotkeys(controller, coerceOptions(options));
};